// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"6b20afe6","371":"ccdf59a7","453":"0c99be00","553":"d6b65098"}[chunkId] + ".chunk.js";
};